/* eslint no-extend-native: ["error", { "exceptions": ["Number"] }] */
Number.prototype.thousand = function (decimals = 0) {
  const thousand = new Intl.NumberFormat(navigator.language);

  return thousand.format(this);
};
